import { render, staticRenderFns } from "./rolePermission.vue?vue&type=template&id=5cdca6fc"
import script from "./rolePermission.vue?vue&type=script&lang=js"
export * from "./rolePermission.vue?vue&type=script&lang=js"
import style0 from "./rolePermission.vue?vue&type=style&index=0&id=5cdca6fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports